import { useSnackbar } from "notistack";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { completeManagerProjectAssignment } from "../../../../store/slices/OpProjectAssignSlices/managerProjectAssignCompleteSlice";
import { fetchAllProjects } from "../../../../store/slices/projectsSlice";
import { useCurrencySymbol } from "../../../../utils/currencyUtils";
import CommaConvert from "../../../../utils/CommaConvert";
import useToolGuideSync from "../../../../features/toolGuide/useToolGuideSync";
import { MANAGER_BUCKET_KEYS } from "../../../../features/toolGuide/toolGuideConfig";

const OmAssignComplete = ({
  row,
  projectTrackingWorkEntries,
  descriptionProjectTracking,
  matchedRowHardwareEntries,
  items,
  entries,
  projects,
  tasks,
  setIsLoading,
  employeeWithTasks,
  isViewOnly = false
}) => {

  const currency = useCurrencySymbol();
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();
  const { syncToolGuideStep } = useToolGuideSync(
    MANAGER_BUCKET_KEYS.PROJECT_ASSIGNED,
    "L4_PM"
  );
  const USAComma = CommaConvert();

  const [confirmAssignPopup, setConfirmAssignPopup] = useState(false);

  const [rowOldProjects, setRowOldProjects] = useState(null);

  useEffect(() => {
    if (projects?.length) {
      const allrowProjects = projects?.filter(
        (pro) => pro.ProjectName === row.ProjectName
      );

      // First filter projects with qualified persons
      const sameTypeServiceProjects = allrowProjects?.filter(
        (project) => project?.TypeService === row.TypeService
      );

      if (sameTypeServiceProjects.length > 1) {
        const setOldProject = sameTypeServiceProjects.find(
          (proj) => proj._id !== row._id
        );
        setRowOldProjects(setOldProject);
      } else {
        setRowOldProjects(sameTypeServiceProjects[0]);
      }
    }
  }, [projects, row]);

  const [oldWorkEntries, setOldWorkEntries] = useState([]);
  const [oldDescriptionEntries, setOldDescriptionEntries] = useState([]);

  useEffect(() => {
    if (!rowOldProjects) return;
    // normalize rowOldProjects?._id
    let projectIds = [];

    if (Array.isArray(rowOldProjects?._id)) {
      projectIds = rowOldProjects._id; // already array
    } else if (rowOldProjects?._id) {
      projectIds = [rowOldProjects._id]; // wrap single id into array
    }

    if (entries?.length > 0) {
      const projectOldWorkEntries = entries.filter((entry) =>
        projectIds.includes(entry.projectid)
      );
      setOldWorkEntries(projectOldWorkEntries);
    }

    if (tasks?.length > 0) {
      const projectOldDescriptions = tasks.filter((entry) =>
        projectIds.includes(entry.projectid)
      );
      setOldDescriptionEntries(projectOldDescriptions);
    }
  }, [entries, tasks, rowOldProjects]);

  const [newWorkEntries, setNewWorkEntries] = useState([]);
  const [newDescriptionEntries, setNewDescriptionEntries] = useState([]);

  useEffect(() => {
    if (projectTrackingWorkEntries?.length > 0) {
      const projectNewWorkEntries = projectTrackingWorkEntries.filter(
        (entry) => entry.projectid === row?._id
      );
      setNewWorkEntries(projectNewWorkEntries);
    }
    if (descriptionProjectTracking?.length > 0) {
      const projectNewDescriptions = descriptionProjectTracking.filter(
        (entry) => entry.projectid === row?._id
      );
      setNewDescriptionEntries(projectNewDescriptions);
    }
  }, [projectTrackingWorkEntries, descriptionProjectTracking, row]);

  const [totalOldHours, setTotalOldHours] = useState(0);
  const [totalNewHours, setTotalNewHours] = useState(0);

  useEffect(() => {
    const total = oldWorkEntries.reduce(
      (sum, entry) => sum + (Number(entry.hoursassigned) || 0),
      0
    );
    setTotalOldHours(total);
  }, [oldWorkEntries]);

  useEffect(() => {
    const total = newWorkEntries.reduce(
      (sum, entry) => sum + (Number(entry.hoursassigned) || 0),
      0
    );
    setTotalNewHours(total);
  }, [newWorkEntries]);

  const [totalOldDescriptionsValue, setTotalOldDescriptionsValue] = useState(0);
  const [totalNewDescriptionsValue, setTotalNewDescriptionsValue] = useState(0);

  useEffect(() => {
    const total = oldDescriptionEntries.reduce(
      (sum, entry) => sum + (Number(entry.value) || 0),
      0
    );
    setTotalOldDescriptionsValue(total);
  }, [oldDescriptionEntries]);

  useEffect(() => {
    const total = newDescriptionEntries.reduce(
      (sum, entry) => sum + (Number(entry.value) || 0),
      0
    );
    setTotalNewDescriptionsValue(total);
  }, [newDescriptionEntries]);

  const handleComplete = async (row) => {
    if (isViewOnly) return;
    syncToolGuideStep("submit-task");
    const projectID = row._id;
    setIsLoading(true);
    try {
      await dispatch(completeManagerProjectAssignment(projectID));
      enqueueSnackbar(`${row.ProjectName} Project Completed Successfully`, {
        variant: "success",
      });
      dispatch(fetchAllProjects());
    } catch {
      enqueueSnackbar(`Completed To Complete ${row.ProjectName}  `, {
        variant: "error",
      });
    } finally {
      setIsLoading(false);
    }
  };

  const [unAssignedPopup, setUnAssignedPopup] = useState(false);
  const [unassignedWorkEntries] = useState([]);
  const [unassignedDescriptions] = useState([]);
  const [completeConfirm, setCompleteConfirm] = useState(false);

  const allComplete =
    row?.Assignedperson?.every(
      (person) =>
        person?.manageraction === "complete" ||
        person?.operationaction === "complete"
    ) && employeeWithTasks?.Assignedperson?.length === 0;


  const allCompleteProject = row?.Assignedperson?.every(
    (person) =>
      (person?.manageraction === "complete" ||
        person?.operationaction === "complete") && person?.projecttracktaskStatus === "submit" && person?.taskStatus === "submit"
  );

  return (
    <div>
      <div className="p-5 flex border-1 border-gray-300 justify-end">
        {allCompleteProject ? (
          // ✅ Show this if all are "project assigned"
          <div className="py-2 px-4 inline-block text-orange-600 border rounded-md text-start bg-gray-100">
            Project submitted & under review
          </div>
        ) : (
          <>
            {row?.TypeService?.toLowerCase().includes("hardware") ? (
              <div
                onClick={() => {
                  if (isViewOnly) return;
                  if (allComplete) {
                    syncToolGuideStep("submit-task");
                    setCompleteConfirm(true);
                  }
                }}
                className={`py-2 px-4 inline-block text-white border rounded-md text-start ${isViewOnly
                  ? "bg-[#e5e7eb] text-[#9ca3af] cursor-not-allowed pointer-events-none"
                  : allComplete
                    ? "bg-blue-500 hover:bg-blue-700 cursor-pointer"
                    : "bg-gray-400 cursor-not-allowed"
                  }`}
              >
                Submit Project
              </div>
            ) : (
              <div
                onClick={() => {
                  if (isViewOnly) return;
                  if (allComplete) {
                    syncToolGuideStep("submit-task");
                    setCompleteConfirm(true);
                  }
                }}
                className={`py-2 px-4 inline-block text-white border rounded-md text-start ${isViewOnly
                  ? "bg-[#e5e7eb] text-[#9ca3af] cursor-not-allowed pointer-events-none"
                  : allComplete
                    ? "bg-blue-500 hover:bg-blue-700 cursor-pointer"
                    : "bg-gray-400 cursor-not-allowed"
                  }`}
              >
                Submit Project
              </div>
            )}
          </>
        )}
      </div>

      {completeConfirm && (
        <div className=" fixed inset-0  flex items-center justify-center bg-black bg-opacity-50 z-[1400]">
          <div className="bg-white rounded-lg p-4 max-w-2xl w-[80%] max-h-[90vh] overflow-auto relative">
            <div className="flex justify-between items-start">
              <h2 className="text-lg font-semibold mb-2">
                ProjectName : {row.ProjectName}
              </h2>
              <button
                onClick={() => setCompleteConfirm(false)}
                className="absolute top-2 right-2 text-red-500 text-xl font-bold mr-6"
              >
                Close
              </button>
            </div>

            <div className="mt-2">
              <>
                <p className="text-[13px] ">
                  Are you sure, you want to submit this project ?
                  {/* named{" "}
                  <b> {row.ProjectName}</b> */}
                </p>
              </>
            </div>
            <div className="flex justify-start gap-4 mt-6">
              <button
                onClick={() => {
                  handleComplete(row);
                  setCompleteConfirm(false);
                }}
                className="py-2 px-7 bg-[#e32278] overflow-hidden shadow-md text-white rounded-lg"
              >
                Yes
              </button>
              <button
                onClick={() => setCompleteConfirm(false)}
                className="py-2 px-7 bg-black hover:bg-white hover:text-black border border-black overflow-hidden shadow-md text-white rounded-lg"
              >
                No
              </button>
            </div>
          </div>
        </div>
      )}

      {unAssignedPopup && (
        <div className=" fixed inset-0  flex items-center justify-center bg-black bg-opacity-50 z-[1400]">
          <div className="bg-white rounded-lg p-4 max-w-2xl w-[80%] max-h-[90vh] overflow-auto relative">
            <div className="flex justify-between items-start">
              <h2 className="text-lg font-semibold mb-2">
                ProjectName : {row.ProjectName}
              </h2>
              <button
                onClick={() => setUnAssignedPopup(false)}
                className="absolute top-2 right-2 text-red-500 text-xl font-bold mr-6"
              >
                Close
              </button>
            </div>

            <div>
              <div>
                <p className="text-base">Unassigned Effort Expenses </p>{" "}
              </div>
              <div className="w-[75%] mt-1">
                <div className="head flex text-center  text-white bg-blue-500 text-xs">
                  <div className="w-[50%] text-[12px] border p-0.5">Task</div>
                  <div className="w-[50%] text-[12px] border p-0.5">Hrs</div>
                </div>
              </div>

              <div className="w-[75%]">
                {unassignedWorkEntries.map((entry, index) => (
                  <div
                    key={index}
                    className="head flex text-center  text-black text-xs"
                  >
                    <div className="w-[50%] text-[12px] border p-0.5">
                      {entry.task}
                    </div>
                    <div className="w-[50%] text-[12px] border p-0.5">
                      {entry.hoursassigned}
                    </div>
                  </div>
                ))}
              </div>
            </div>

            <div>
              <div>
                <p className="text-base">Unassigned Other Expenses List </p>{" "}
              </div>
              <div className="w-[75%] mt-1">
                <div className="head flex text-center  text-white bg-blue-500 text-xs">
                  <div className="w-[50%] text-[12px] border p-0.5">
                    Description
                  </div>
                  <div className="w-[50%] text-[12px] border p-0.5">
                    Amount ({currency})
                  </div>
                </div>
              </div>

              <div className="w-[75%]">
                {unassignedDescriptions.map((entry, index) => (
                  <div
                    key={index}
                    className="head flex text-center  text-black text-xs"
                  >
                    <div className="w-[50%] text-[12px] border p-0.5">
                      {entry.description}
                    </div>
                    <div className="w-[50%] text-[12px] border p-0.5">
                      {entry.value}
                    </div>
                  </div>
                ))}
              </div>
            </div>

            <div className="mt-2">
              <>
                <p className="text-[13px] ">
                  You Cannot complete this <strong>{row.ProjectName}</strong>{" "}
                  Project,
                  <br /> Because above tasks or other expenses are unassigned or
                  are not submitted by Operation Person
                </p>
              </>
            </div>
          </div>
        </div>
      )}

      {confirmAssignPopup && (
        // assignProjectDetails &&
        <div className=" fixed inset-0  flex items-center justify-center bg-black bg-opacity-50 z-[1400]">
          <div className="bg-white rounded-lg p-4 max-w-2xl w-[80%] max-h-[90vh] overflow-auto relative">
            <div className="flex justify-between items-start">
              <h2 className="text-lg font-semibold mb-2">
                ProjectName : {row.ProjectName}
              </h2>
              <button
                onClick={() => setConfirmAssignPopup(false)}
                className="absolute top-2 right-2 text-red-500 text-xl font-bold mr-6"
              >
                Close
              </button>
            </div>

            <div>
              <div>
                <p className="text-base">Effort Expenses Hours Evaluation : </p>{" "}
              </div>
              <div className="w-[75%] mt-1">
                <div className="head flex text-center  text-white bg-blue-500 text-xs">
                  <div className="w-[50%] text-[12px] border p-0.5">
                    Client Approved Total Hours
                  </div>
                  <div className="w-[50%] text-[12px] border p-0.5">
                    Manager Assigned Total Hours
                  </div>
                </div>
              </div>

              <div className="w-[75%]">
                <div className="head flex text-center  text-black text-xs">
                  <div className="w-[50%] text-[12px] border p-0.5">
                    {totalOldHours} Hrs
                  </div>
                  <div className="w-[50%] text-[12px] border p-0.5">
                    {totalNewHours} Hrs
                  </div>
                </div>
              </div>
            </div>
            {totalOldHours <= totalNewHours && (
              <div>
                <p className="text-[13px] mt-1">
                  Manager Assigned Hours for this project are greater that
                  Client Approved Hours.
                </p>

                <p className="text-[10px]">
                  ( Manager Assigned Hours must be same or less than Client
                  Approved Hours ).
                </p>
              </div>
            )}

            <div className="mt-2">
              <div>
                <p className="text-base">OtherExpenses Value Evaluation : </p>{" "}
              </div>
              <div className="w-[75%] mt-1">
                <div className="head flex text-center  text-white bg-blue-500 text-xs">
                  <div className="w-[50%] text-[12px] border p-0.5">
                    Client Approved Total {currency} Value
                  </div>
                  <div className="w-[50%] text-[12px] border p-0.5">
                    Manager Assigned Total {currency} Value
                  </div>
                </div>
              </div>

              <div className="w-[75%]">
                <div className="head flex text-center  text-black text-xs">
                  <div className="w-[50%] text-[12px] border p-0.5">
                    {currency}{USAComma(totalOldDescriptionsValue)}
                  </div>
                  <div className="w-[50%] text-[12px] border p-0.5">
                    {currency} {USAComma(totalNewDescriptionsValue)}
                  </div>
                </div>
              </div>
            </div>

            <div className="mt-2">
              {totalOldDescriptionsValue < totalNewDescriptionsValue && (
                <>
                  <p className="text-[13px] ">
                    Manager Assigned OtherExpenses Value for this project are
                    greater that Client Approved OtherExpenses Value.
                  </p>

                  <p className="text-[10px]">
                    ( Manager Assigned OtherExpenses Value must be equal or less
                    than Client Approved OtherExpenses Value ).
                  </p>
                </>
              )}

              {totalOldHours < totalNewHours &&
                totalOldDescriptionsValue < totalNewDescriptionsValue && (
                  <p className="text-[13px] mt-2 text-red-500">
                    So, Cannot complete this <strong> {row.ProjectName}</strong>{" "}
                    Project.
                  </p>
                )}

              {totalOldHours >= totalNewHours &&
                totalOldDescriptionsValue >= totalNewDescriptionsValue && (
                  <p className="text-[13px] mt-2 ">
                    Manager Assigned Hours & OtherExpenses Value for this
                    project are equal or less than Client Approved Hours &
                    OtherExpenses Value.
                  </p>
                )}

              {totalOldHours >= totalNewHours &&
                totalOldDescriptionsValue >= totalNewDescriptionsValue && (
                  <p className="text-base mt-2 text-black">
                    So, You can complete this{" "}
                    <strong> {row.ProjectName}</strong> Project.
                  </p>
                )}

              {totalOldHours >= totalNewHours &&
                totalOldDescriptionsValue >= totalNewDescriptionsValue && (
                  <div className="flex justify-start gap-4 mt-6">
                    <button
                      disabled={isViewOnly}
                      onClick={() => {
                        if (isViewOnly) return;
                        handleComplete(row);
                        setConfirmAssignPopup(false);
                      }}
                      className={`py-2 px-7 overflow-hidden shadow-md text-white rounded-lg ${isViewOnly ? "bg-[#e5e7eb] text-[#9ca3af] cursor-not-allowed" : "bg-[#e32278]"}`}
                    >
                      Yes
                    </button>
                    <button className="py-2 px-7 bg-black hover:bg-white hover:text-black border border-black overflow-hidden shadow-md text-white rounded-lg">
                      No
                    </button>
                  </div>
                )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default OmAssignComplete;
